/*
 * @description: 
 * @author: Jason Wong
 * @since: 2022-03-17 10:32:40
 */
import Vue from 'vue'
import SvgIcon from '../../components/svgIcon.vue';// svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', true, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);